import React from "react";
import Circulo from "../images/circulo_niños.png";

import ModuleCard from "../components/ModuleCard";
import { modules } from "../routes.js"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons";

const Home = () => {
 
  console.log('ListRoutes',modules)
  return (
    <>
      <header className="header-home">
        <div className="container h-100 pt-5">
          <div className="row align-items-center h-100">
            <div className="col-md-6 p-0 p-md-4">
              <h1 >Actividades interactivas</h1>
              <h3 className="mb-4">(Módulos de aprendizaje)</h3>
              <div className="pe-5 pe-xs-0">
                <p>
                  La Fundación Gustavo Mohme Llona pone a tu disposición módulos
                  de descarga gratuita con contenido sobre ciudadanía y valores
                  democráticos para sesiones de aprendizaje de Personal Social.
                </p>
                <p>
                  Se trata de recursos que promueven el desarrollo de
                  competencias de convivencia, deliberación y participación, y
                  que han sido diseñados para trabajar con imágenes, ampliar el
                  vocabulario, promover el diálogo y elaborar un producto en el
                  que se pongan en práctica las habilidades y contenidos
                  desarrollados en cada módulo. Sus contenidos se alinean con el
                  currículo oficial del Ministerio de Educación del Perú.
                </p>
                <p>
                  Todos los módulos pueden ser trabajados en la escuela, con la
                  guía del maestro o maestra, o en casa con el acompañamiento de
                  un familiar.
                </p>
                <div className="w-100">
          <a href='#modulos' className={`c btn-module`}>
            Explorar los 14 módulos de aprendizaje <FontAwesomeIcon icon={faLongArrowAltRight} />
          </a>
        </div>
        <div className="w-100">
          <a href='https://ciudadania.pe/' className={`c btn-module`}>
            Explorar otros recursos en Ciudadanía.pe <FontAwesomeIcon icon={faLongArrowAltRight} />
          </a>
        </div>
              </div>
            </div>
            <div className="col-md-6">
              <img src={Circulo} alt="Estudiantes" className="img-fluid" />
            </div>
          </div>
        </div>
      </header>
      <div className="container container-modules py-5" id="modulos">
        <div className="row gy-4">
          {modules.map((m, i) => (
            <div className="col-md-4 col-12 col-sm-6" key={i}>
              <ModuleCard content={m} />
            </div>
          ))}
        </div>
      </div>
      <footer className="bg-light p-5">
        <div className="container">
          <p className="text-center">
            Contenidos desarrollados por{" "}
            <strong>
              Carolina de Belaunde, Mariana Eguren y Natalia González (Instituto de Estudios Peruanos - IEP)
            </strong>
            . Ilustraciones de{" "}
            <strong>Gabriel Alayza y Mateo Alayza (Hermanos Magia)</strong>.
          </p>
        </div>
      </footer>
    </>
  );
};

export default Home;
